import { GetStaticProps } from 'next';

import Meta from '@components/Meta';
import { WhatYouCanExpectSection as WhatYouCanExpect } from '@components/HowItWorks/WhatYouCanExpect/WhatYouCanExpectSection';
import { OurProgramme } from '@components/HowItWorks/OurProgramme';
import { Hero } from '@components/Hero/Hero';
import { Footer } from '@components/Footer/Footer';
import { ReferencesRibbon } from '../common/ReferencesRibbon';
import { SignPost } from '../common/SignPost';

import { getStaticTranslationProps } from '@nextUtils/translations';
import { HowItWorksTranslationType } from '@nextTypes/translations';
import { TakeOurQuizCTA } from '../components/Hero/TakeOurQuizCTA';
import { normalProgrammePageStructuredData } from '@common/structuredData';

import HeroImage from '@public/img/how-it-works/hero.jpeg';

export const getStaticProps: GetStaticProps =
  getStaticTranslationProps<HowItWorksTranslationType>('HowItWorks');

type Props = {
  utmCampaign: string;
  utmMedium: string;
};

const HowItWorks = ({ utmCampaign, utmMedium }: Props): JSX.Element => (
  <>
    <Meta
      metaDescription="Second Nature’s 12 week healthy lifestyle programme helps you to lose weight by changing your diet, activity levels, and behaviours"
      relativeCanonicalURL="/how-it-works"
      title="How Does it Work? | The Second Nature Programme"
      structuredData={normalProgrammePageStructuredData}
    />
    <Hero
      title={
        <span className="text-mono-white">
          “It truly is a <span className="text-blue">much happier</span> way of
          life.”
        </span>
      }
      subtitle={<span className="text-dawn-blue-400">Zoe, Sheffield</span>}
      image={HeroImage}
      altText="Woman smiling"
      color="bg-dawn-blue"
      ctaChildren={
        <TakeOurQuizCTA
          utmMedium={utmMedium}
          utmCampaign={utmCampaign}
          location="How it works"
        />
      }
      placeholder="blur"
      priority
    />
    <WhatYouCanExpect />
    <OurProgramme />
    <SignPost version="B" utmMedium={utmMedium} utmCampaign={utmCampaign} />
    <ReferencesRibbon />
    <Footer />
  </>
);

export default HowItWorks;
